module.exports = __webpack_public_path__ + "static/media/kaligreen.2da60333.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/cenicilla_pepino/preventiva/kaligreen.png
// module id = 2102
// module chunks = 3